import React from 'react';
import PropTypes from 'prop-types';

import EplusPropTypes from '../../../propTypes';
import Statuses from '../../../../model/Statuses';
import ValueView from './ValueView';
import withTranslations from '../../utils/Translations/withTranslations';
import translatePropTypes from '../../../translatePropTypes';
import Status from '../../utils/Status';

@withTranslations
export default class StatusValueView extends React.PureComponent {
  static propTypes = {
    value: EplusPropTypes.status,
    hasLabel: PropTypes.bool,
    label: PropTypes.string,
    ...translatePropTypes,
  };

  static defaultProps = {
    value: null,
    hasLabel: true,
    label: 'Status',
  };

  render() {
    const { t, value, hasLabel, label } = this.props;

    const status = Statuses.BasicByValue[value];

    return (
      <ValueView
        label={label && t(label)}
        noLabel={!hasLabel}
        value={<Status value={status && status.value} />}
      />
    );
  }
};
